import { Flex, Box } from '@elparking/components'
import React from 'react'
import PropTypes from 'prop-types'
import AirportSwitcher from '../AirportSwitcher'
import FilterButton, { ButtonEmpty, ButtonWithFilters } from 'parking-search-map/js/ui/FilterButton'

export {
    ButtonEmpty,
    ButtonWithFilters,
}

const FilterBar = ({parkingType, onChangeAirportFilter, filterNumber, onShowFilters}) => (
    <Flex flex={['1 1 100%']} flexWrap='wrap' justifyContent='start' w='100%'>
        <Box mr='18px'>
            <AirportSwitcher selected={parkingType} onChange={onChangeAirportFilter} />
        </Box>
        <Box>
            <FilterButton filterNumber={filterNumber} onShowFilters={onShowFilters} />
        </Box>
    </Flex>
)

FilterBar.propTypes = {
    parkingType: PropTypes.string,
    onChangeAirportFilter: PropTypes.func,
    onShowFilters: PropTypes.func,
    filterNumber: PropTypes.number,
}

FilterBar.defaultProps = {
    filterNumber: 0,
}

export default FilterBar
